// import React, { useState, useEffect } from 'react';
// import Table from 'react-bootstrap/Table';
// import Navbar from '../../Components/Navbar';
// import Modal from 'react-bootstrap/Modal';
// //import Button from 'react-bootstrap/Button';
// import { Button, Spinner } from "react-bootstrap";
// import Form from 'react-bootstrap/Form';
// import '../Secretary/Table.css';
// import axios from 'axios';
// import { API_BASE_URL } from '../../config';

// export default function RequestApproval() {
//   const [showEmailModal, setShowEmailModal] = useState(false);
//   const [currentApp, setCurrentApp] = useState(null);
//   const [reportType, setReportType] = useState('');
//   const [emailBody, setEmailBody] = useState('');
//   const [recipientRole, setRecipientRole] = useState('');
//   const [recipientName, setrecipientName] = useState('');
//   const [recipientEmail, setRecipientEmail] = useState('');
//   const [applications, setApplications] = useState([]);
//   const [name, setName] = useState('');
//   const [loading, setLoading] = useState(false); // Track loading state
//   const [filteredApplications, setFilteredApplications] = useState([]);
//   const [selectedYear, setSelectedYear] = useState("");

//   const currentYear = new Date().getFullYear();
// const startYear = 2024; // Adjust as needed
// const years = Array.from(
//   { length: currentYear - startYear + 1 },
//   (_, i) => startYear + i
// ).reverse(); // Reverse to show latest years first


//  useEffect(() => {
//   const fetchApplications = async () => {
//     try {
//       const response = await axios.get(`${API_BASE_URL}/RequestApproval.php`);
//       setApplications(response.data);
//       if (selectedYear === "") {
//         setFilteredApplications(response.data); // Show all applications
//       } else {
//         setFilteredApplications(
//           response.data.filter((app) => {
//             const appYear = new Date(app.submittedDate).getFullYear();
//             return appYear === parseInt(selectedYear);
//           })
//         );
//       }
//     } catch (error) {
//       console.error('Error fetching applications:', error);
//     }
//   };
//   fetchApplications();
// }, [selectedYear]);
//   const handleCloseEmail = () => setShowEmailModal(false);

//   const handleShowEmail = (appId, role, email) => {
//     const selectedApp = applications.find(app => app.app_ID === appId);
//     if (selectedApp) {
//       setCurrentApp(selectedApp);
//       setReportType(role);
//       setRecipientRole(role);
//       setrecipientName(name);
//       setRecipientEmail(email);

//       // Construct the clickable link for the email body
//       // const DeanHODLink = `${window.location.origin}/${role.toLowerCase()}?app_ID=${appId}&Role=${role}`;
//       const DeanHODLink = `${window.location.origin}/${role.toLowerCase()}?app_ID=${appId}&Role=${role}`;

//       setEmailBody(`
//         Dear  Dean/Head of the Department,<br /><br />
//         I hope this message finds you well.<br /><br />
//         We are excited to announce the opening of applications for the Annual Multidisciplinary Research Grant Scheme this year. This program aims to promote collaborative research across various faculties, addressing critical research questions with the potential for meaningful impact.<br /><br />
//         In this regard, we kindly request your approval for a multidisciplinary research grant proposal titled "${selectedApp.projectTitle}"submitted by a member of your faculty/department.<br /><br />
//         Please use the following link to access the project details and approve the grant funding:</span> <a href="${DeanHODLink}" target="_blank">${DeanHODLink}.</a>
//         After reviewing the information, please select a decision, add any necessary comments, and then submit.
//         <br /><br />
//         With best regards<br><br />
//         Janaka<br><br />
//         <span style="color: blue;">Prof. Janaka Ekanayake</span><br><br />
//         <span style="color: blue;">BScEng(Hons), PhD, FIEEE (USA), FIET (UK), FNAS (SL), FIESL, CEng</span><br><br />
//         <span style="color: blue;">Senior Professor and Chair of Electrical and Electronic Engineering</span><br><br />
//         <span style="color: blue;">Director, University Research Council</span><br><br />
//         <span style="color: blue;">University of Peradeniya, Sri Lanka</span><br><br />
//         <span style="color: blue;">Tel: +94 777146979</span><br><br />
//         <span style="color: blue;">Email: <a href="mailto:EkanayakeJ@eng.pdn.ac.lk" style="color: blue;">EkanayakeJ@eng.pdn.ac.lk</a></span>`);

        
//     } else {
//       console.error('Application not found for ID:', appId);
//     }
//     setShowEmailModal(true);
//   };

  
//   const handleSendEmail = async () => {
//     setLoading(true);

//     try {
//         const emailResponse = await axios.post(`${API_BASE_URL}/Email.php`, {
//             email: recipientEmail,
//             subject: `APPROVE PROJECT: ${currentApp.projectTitle}`,
//             message: emailBody,
//         });

//         if (emailResponse.data.status === "success") {
//             alert("Email sent successfully!");

//             // Determine whether to update Dean or HOD table
//             const approvalAPI = recipientRole === "Dean" ? "SaveDean.php" : "SaveHOD.php";

//             // Update the respective table
//             await axios.post(`${API_BASE_URL}/${approvalAPI}`, {
//                 app_ID: currentApp.app_ID,
//                 email: recipientEmail,
//                 name: recipientName,
//             });

//             console.log("Email and approval update successful.");
//         } else {
//             alert(`Failed to send email: ${emailResponse.data.message}`);
//         }
//     } catch (error) {
//         alert("Error sending email. Please try again.");
//         console.error("Error:", error);
//     } finally {
//         setLoading(false);
//         handleCloseEmail();
//     }
// };


//   const handleDecision = (appId, decision, role) => {
//     console.log(`Decision for application ${appId} by ${role}: ${decision}`);
//     // Add logic to handle decision (approve/reject)
//   };

//   return (
//     <div>
//       <Navbar />
//       <h1 className="page-title">Request Approval</h1>
//       <div className="year-filter">
//   <label htmlFor="year-select">Year: </label>
//   <select
//     id="year-select"
//     value={selectedYear}
//     onChange={(e) => setSelectedYear(e.target.value)}
//     className="year-select"
//   >
//     <option value="">Select Year</option>
//     {years.map((year) => (
//       <option key={year} value={year}>
//         {year}
//       </option>
//     ))}
//   </select>
// </div>
//       <Table striped bordered hover>
//         <thead>
//           <th colSpan={6} className='title'>
//             <label>All Shortlisted Applications</label>
//           </th>
//           <tr>
//             <th>Application ID</th>
//             <th>Project Title</th>
//             <th>Submitted Date</th>
//             <th>Status (HOD)</th>
//             <th>Status (Dean)</th>
//           </tr>
//         </thead>
//         <tbody>
//           {filteredApplications.map((app) => (
//             <tr key={app.app_ID}>
//               <td>{app.app_ID}</td>
//               <td>{app.projectTitle}</td>
//               <td>{app.submittedDate}</td>
//               <td>
//                 {app.hod_decision === '3.1' ? (
//                   <>
//                     <button className="btn-approved" onClick={() => handleDecision(app.app_ID, 'Approved', 'HOD')}>Approve</button>
                   
//                   </>
//                 ) : app.hod_decision === '3.2' ? (
//                   <>
//                   <button className="btn-rejected" onClick={() => handleDecision(app.app_ID, 'Rejected', 'HOD')}>Reject</button>
                 
//                   </>
                  
//                 ) : app.Status === '2.1' ? (
//                   <>
//                     {/* <button className="btn-approved" onClick={() => handleDecision(app.app_ID, 'Approved', 'HOD')}>Approve</button>
//                     <button className="btn-rejected" onClick={() => handleDecision(app.app_ID, 'Rejected', 'HOD')}>Reject</button> */}
//                     <span className='NotAvailable-button'>Status: Pending</span>
//                     <button className="Email-button" 
//                     onClick={() => handleShowEmail(app.app_ID, 'HOD', app.hodEmail)}
//                     style={{ backgroundColor: Number(app.hod_sent) === 1 ? '#6F42C1' : '#052659' }} // Change color if sent = 1
//                     >
//                     Send Email</button>
//                   </>
//                 ) : null}
//               </td>
//               <td>
//                 {app.dean_decision === '3.1' ? (
//                   <>
//                     <button className="btn-approved" onClick={() => handleDecision(app.app_ID, 'Approved', 'Dean')}>Approve</button>
                   
//                   </>
//                 ) : app.dean_decision === '3.2' ? (
//                   <>
//                   <button className="btn-rejected" onClick={() => handleDecision(app.app_ID, 'Rejected', 'Dean')}>Reject</button>
                  
//                   </>
//                 ) : app.Status === '2.1' ? (
//                   <>
//                     {/* <button className="btn-approved" onClick={() => handleDecision(app.app_ID, 'Approved', 'Dean')}>Approve</button>
//                     <button className="btn-rejected" onClick={() => handleDecision(app.app_ID, 'Rejected', 'Dean')}>Reject</button> */}
//                     {/* <button className="NotAvailable-button" onClick={() => handleDecision(app.app_ID, 'Pending', 'Dean')}>Status : Pending </button>  */}
//                     <span className='NotAvailable-button'>Status: Pending</span>
//                     <button className="Email-button" 
//                     onClick={() => handleShowEmail(app.app_ID, 'Dean', app.deanEmail)}
//                     style={{ backgroundColor: Number(app.dean_sent) === 1 ? '#6F42C1' : '#052659' }} // Change color if sent = 1
//                     >Send Email</button>
//                   </>
//                 ) : null}
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </Table>

//       {/* Send Email Modal */}
//       <Modal show={showEmailModal} onHide={handleCloseEmail}>
//         <Modal.Header closeButton>
//           <Modal.Title>Send Email to {recipientRole}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group controlId="formProjectTitle">
//               <Form.Label>Project Title</Form.Label>
//               <Form.Control type="text" value={currentApp ? currentApp.projectTitle : ''} readOnly />
//             </Form.Group>

//             <Form.Group controlId="formRecipientRole">
//               <Form.Label>Recipient Role</Form.Label>
//               <Form.Control type="text" value={recipientRole} readOnly />
//             </Form.Group>

//             {/* Editable Name Field */}
//             <Form.Group controlId="formRecipientName">
//               <Form.Label>Recipient Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={recipientName}
//                 onChange={(e) => setrecipientName(e.target.value)}  // Update the state when the user types
//               />
//             </Form.Group>

//             {/* Editable Email Field */}
//             <Form.Group controlId="formRecipientEmail">
//               <Form.Label>Recipient Email</Form.Label>
//               <Form.Control
//                 type="email"
//                 value={recipientEmail}
//                 onChange={(e) => setRecipientEmail(e.target.value)}  // Update the state when the user types
//               />
//             </Form.Group>

//             <Form.Group controlId="formEmailBody">
//   <Form.Label>Email Body</Form.Label>
//   <Form.Control
//     as="textarea"
//     rows={6}
//     value={emailBody}
//     onChange={(e) => setEmailBody(e.target.value)}
//   />
// </Form.Group>
//           </Form>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseEmail}>Cancel</Button>
//           <Button variant="primary" onClick={handleSendEmail} disabled={loading}>
//       {loading ? (
//         <>
//           <Spinner animation="border" size="sm" role="status" /> Sending Email...
//         </>
//       ) : (
//         "Send"
//       )}
//     </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Navbar from '../../Components/Navbar';
import Modal from 'react-bootstrap/Modal';
import { Button, Spinner } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import '../Secretary/Table.css';
import axios from 'axios';
import { API_BASE_URL } from '../../config';

export default function RequestApproval() {
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [currentApp, setCurrentApp] = useState(null);
  const [reportType, setReportType] = useState('');
  const [emailBody, setEmailBody] = useState('');
  const [recipientRole, setRecipientRole] = useState('');
  const [recipientName, setrecipientName] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('');
  const [applications, setApplications] = useState([]);
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [filteredApplications, setFilteredApplications] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");

  const currentYear = new Date().getFullYear();
  const startYear = 2024;
  const years = Array.from(
    { length: currentYear - startYear + 1 },
    (_, i) => startYear + i
  ).reverse();

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/RequestApproval.php`);
        setApplications(response.data);
        if (selectedYear === "") {
          setFilteredApplications(response.data);
        } else {
          setFilteredApplications(
            response.data.filter((app) => {
              const appYear = new Date(app.submittedDate).getFullYear();
              return appYear === parseInt(selectedYear);
            })
          );
        }
      } catch (error) {
        console.error('Error fetching applications:', error);
      }
    };
    fetchApplications();
  }, [selectedYear]);

  const handleCloseEmail = () => setShowEmailModal(false);

  const handleShowEmail = (appId, role, email) => {
    const selectedApp = applications.find(app => app.app_ID === appId);
    if (selectedApp) {
      setCurrentApp(selectedApp);
      setReportType(role);
      setRecipientRole(role);
      setrecipientName(name);
      setRecipientEmail(email);
      const DeanHODLink = `${window.location.origin}/${role.toLowerCase()}?app_ID=${appId}&Role=${role}`;
      setEmailBody(`
        Dear Dean/Head of the Department,<br><br>
        I hope this message finds you well.<br><br>
        We are excited to announce the opening of applications for the Annual Multidisciplinary Research Grant Scheme this year. This program aims to promote collaborative research across various faculties, addressing critical research questions with the potential for meaningful impact.<br><br>
        In this regard, we kindly request your approval for a multidisciplinary research grant proposal titled "${selectedApp.projectTitle}" submitted by a member of your faculty/department.<br><br>
        Please use the following link to access the project details and approve the grant funding: <a href="${DeanHODLink}" target="_blank">${DeanHODLink}</a>.<br>
        After reviewing the information, please select a decision, add any necessary comments, and then submit.<br><br>
        With best regards,<br><br>
        Janaka<br><br>
        <span style="color: blue;">Prof. Janaka Ekanayake</span><br><br>
        <span style="color: blue;">BScEng(Hons), PhD, FIEEE (USA), FIET (UK), FNAS (SL), FIESL, CEng</span><br><br>
        <span style="color: blue;">Senior Professor and Chair of Electrical and Electronic Engineering</span><br><br>
        <span style="color: blue;">Director, University Research Council</span><br><br>
        <span style="color: blue;">University of Peradeniya, Sri Lanka</span><br><br>
        <span style="color: blue;">Tel: +94 777146979</span><br><br>
        <span style="color: blue;">Email: <a href="mailto:EkanayakeJ@eng.pdn.ac.lk" style="color: blue;">EkanayakeJ@eng.pdn.ac.lk</a></span>`);
    } else {
      console.error('Application not found for ID:', appId);
    }
    setShowEmailModal(true);
  };

  const handleSendEmail = async () => {
    setLoading(true);
    try {
      const emailResponse = await axios.post(`${API_BASE_URL}/Email.php`, {
        email: recipientEmail,
        subject: `APPROVE PROJECT: ${currentApp.projectTitle}`,
        message: emailBody,
      });
      if (emailResponse.data.status === "success") {
        alert("Email sent successfully!");
        const approvalAPI = recipientRole === "Dean" ? "SaveDean.php" : "SaveHOD.php";
        await axios.post(`${API_BASE_URL}/${approvalAPI}`, {
          app_ID: currentApp.app_ID,
          email: recipientEmail,
          name: recipientName,
        });
        console.log("Email and approval update successful.");
      } else {
        alert(`Failed to send email: ${emailResponse.data.message}`);
      }
    } catch (error) {
      alert("Error sending email. Please try again.");
      console.error("Error:", error);
    } finally {
      setLoading(false);
      handleCloseEmail();
    }
  };

  const handleDecision = (appId, decision, role) => {
    console.log(`Decision for application ${appId} by ${role}: ${decision}`);
  };

  // Handle contentEditable changes
  const handleEmailBodyChange = (e) => {
    setEmailBody(e.target.innerHTML);
  };

  return (
    <div>
      <Navbar />
      <h1 className="page-title">Request Approval</h1>
      <div className="year-filter">
        <label htmlFor="year-select">Year: </label>
        <select
          id="year-select"
          value={selectedYear}
          onChange={(e) => setSelectedYear(e.target.value)}
          className="year-select"
        >
          <option value="">Select Year</option>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>
      <Table striped bordered hover>
        <thead>
          <th colSpan={6} className='title'>
            <label>All Shortlisted Applications</label>
          </th>
          <tr>
            <th>Application ID</th>
            <th>Project Title</th>
            <th>Submitted Date</th>
            <th>Status (HOD)</th>
            <th>Status (Dean)</th>
          </tr>
        </thead>
        <tbody>
          {filteredApplications.map((app) => (
            <tr key={app.app_ID}>
              <td>{`${app.app_ID}_${new Date().getFullYear()}`}</td>
              <td>{app.projectTitle}</td>
              <td>{app.submittedDate}</td>
              <td>
                {app.hod_decision === '3.1' ? (
                  <>
                    <button className="btn-approved" onClick={() => handleDecision(app.app_ID, 'Approved', 'HOD')}>Approve</button>
                  </>
                ) : app.hod_decision === '3.2' ? (
                  <>
                    <button className="btn-rejected" onClick={() => handleDecision(app.app_ID, 'Rejected', 'HOD')}>Reject</button>
                  </>
                ) : app.Status === '2.1' ? (
                  <>
                    <span className='NotAvailable-button'>Status: Pending</span>
                    <button
                      className="Email-button"
                      onClick={() => handleShowEmail(app.app_ID, 'HOD', app.hodEmail)}
                      style={{ backgroundColor: Number(app.hod_sent) === 1 ? '#6F42C1' : '#052659' }}
                    >
                      Send Email
                    </button>
                  </>
                ) : null}
              </td>
              <td>
                {app.dean_decision === '3.1' ? (
                  <>
                    <button className="btn-approved" onClick={() => handleDecision(app.app_ID, 'Approved', 'Dean')}>Approve</button>
                  </>
                ) : app.dean_decision === '3.2' ? (
                  <>
                    <button className="btn-rejected" onClick={() => handleDecision(app.app_ID, 'Rejected', 'Dean')}>Reject</button>
                  </>
                ) : app.Status === '2.1' ? (
                  <>
                    <span className='NotAvailable-button'>Status: Pending</span>
                    <button
                      className="Email-button"
                      onClick={() => handleShowEmail(app.app_ID, 'Dean', app.deanEmail)}
                      style={{ backgroundColor: Number(app.dean_sent) === 1 ? '#6F42C1' : '#052659' }}
                    >
                      Send Email
                    </button>
                  </>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showEmailModal} onHide={handleCloseEmail} size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Send Email to {recipientRole}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formProjectTitle">
              <Form.Label>Project Title</Form.Label>
              <Form.Control type="text" value={currentApp ? currentApp.projectTitle : ''} readOnly />
            </Form.Group>
            <Form.Group controlId="formRecipientRole">
              <Form.Label>Recipient Role</Form.Label>
              <Form.Control type="text" value={recipientRole} readOnly />
            </Form.Group>
            <Form.Group controlId="formRecipientName">
              <Form.Label>Recipient Name</Form.Label>
              <Form.Control
                type="text"
                value={recipientName}
                onChange={(e) => setrecipientName(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formRecipientEmail">
              <Form.Label>Recipient Email</Form.Label>
              <Form.Control
                type="email"
                value={recipientEmail}
                onChange={(e) => setRecipientEmail(e.target.value)}
              />
            </Form.Group>
            <Form.Group controlId="formEmailBody">
              <Form.Label>Email Body</Form.Label>
              <div
                className="email-body-preview"
                contentEditable="true"
                onInput={handleEmailBodyChange}
                dangerouslySetInnerHTML={{ __html: emailBody }}
                style={{
                  border: '1px solid #ced4da',
                  padding: '10px',
                  minHeight: '150px',
                  backgroundColor: '#fff',
                  borderRadius: '4px',
                  outline: 'none',
                }}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseEmail}>Cancel</Button>
          <Button variant="primary" onClick={handleSendEmail} disabled={loading}>
            {loading ? (
              <>
                <Spinner animation="border" size="sm" role="status" /> Sending Email...
              </>
            ) : (
              "Send"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}